(function() {
    'use strict';

    angular
        .module('app')
        .directive('libraryNameSwitch', libraryNameSwitch);

    libraryNameSwitch.$inject = ['$window', '$timeout', 'loginService'];
    
    function libraryNameSwitch($window, $timeout, loginService) {
        // Usage:
        //     <libraryNameSwitch></libraryNameSwitch>
        // Creates:
        // 
        var directive = {
            link: link,
            restrict: 'EA',
            template: '<div class="name-switch"><div ng-show="show" class="nm-dropdown"><div>Display</div><div class="ns-selection" ng-click="selectionMade(false)"><i ng-hide="fileGuideService.showFolder" class="fa fa-check" aria-hidden="true"></i>Name</div><div class="ns-selection" ng-click="selectionMade(true)"><i ng-show="fileGuideService.showFolder" class="fa fa-check" aria-hidden="true"></i>Folder</div></div><div class="ns-button" ng-click="toggleDisplay()"><i class="fa fa-gear" aria-hidden="true"></i></div><div>',
            controllerAs: 'vm',
            controller: 'libraryNameSwitch',
            scope: {
                showFolder: '='
            }
        };
        return directive;

        function link(scope, element, attrs) {
            var dropdown = $(element).find(".nm-dropdown");
            
            function bindToClose(event) {
                if (!$(event.target).closest('.nm-dropdown').length) {
                    scope.show = false;
                    scope.$apply();
                }
            }

            scope.$watch(function () {
                return scope.show;
            }, function(value) {
                if (value) {
                    $timeout(function() {
                        $(document).click(bindToClose);
                    }, 200);
                    
                }
                else {
                    $(document).unbind("click", bindToClose);
                }
            })
                
            
            
        }
    }

})();